import { useNovelCustomerSelector } from "@customer-gallery/redux/reduxHooks";
import React from "react";
import GalleryWrapper from "./GalleryWrapper";
interface Props {
  readonly children?: React.ReactNode;
}
export function CustomerPortalLayout({
  children
}: Props): JSX.Element {
  const user = useNovelCustomerSelector(state => state.auth.user);
  const addresses = useNovelCustomerSelector(state => state.addresses.cryptoAddresses);
  return <React.Fragment>
            <GalleryWrapper user={user} addresses={addresses}>
                {children}
            </GalleryWrapper>
            <style global jsx>{`
                .claiming-modal-nft-image {
                    width: 100%;
                    border-radius: 20px;
                    overflow: hidden;
                }
                .claiming-modal-nft-image > * {
                    filter: brightness(100%) !important;
                }
                .Polaris-Navigation__Badge {
                    height: 2.4rem;
                    // width: 2.4rem;
                }
                .Polaris-Badge--statusNew {
                    height: 100%;
                    width: 100%;
                }
            `}</style>
        </React.Fragment>;
}